import { AddPartnersToBidRequestApiQueryArgs } from "../types/api";
import { AddPartnersToBidRequestQueryArgs } from "../types/domain";

export const transformFromAddPartnersToBidRequestQueryArgs = (
  queryArgs: AddPartnersToBidRequestQueryArgs
): AddPartnersToBidRequestApiQueryArgs => queryArgs;
